import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { CheckVersionRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { CheckVersionResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const checkVersion = (request: CheckVersionRequest, options?: CashRequestOptions) =>
  post<CheckVersionRequest, CheckVersionResponse>('/2.0/cash/check-version', request, {
    ...options,
    rejectOnError: true,
  })
